import React from 'react';

import { brandIcons } from '../../config/branding';

interface CustomRadioButtonProperties {
  selected: boolean;
  label: string;
  value: string;
  name: string;
  onChangeFunc: (name: string, value: string) => void;
  fontSize?: 'small' | 'medium' | 'large';
}

/**
 * Custom radio button component
 * @param {any} properties - The properties
 */
function CustomRadioButton(properties: CustomRadioButtonProperties) {
  const { selected, label, value, name, onChangeFunc, fontSize = 'large' } = properties;
  return (
    <div
      className={`custom-radio-button-wrap ${fontSize}`}
      role="presentation"
      onClick={() => onChangeFunc(name, value)}>
      {selected ? (
        <brandIcons.CheckBoxActiveIcon color="var(--primary-color)" />
      ) : (
        <brandIcons.CheckBoxIcon color="var(--primary-color)" />
      )}
      <p className="radio-button-label">{label}</p>
    </div>
  );
}

export default CustomRadioButton;